var _rect, _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisDeactivatedIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#9BA5AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_186068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7122 16.8088H29.2423V11.1942V9.66406H27.7122H20.1562V11.1942H27.7122V16.8088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3279 22.2188H12.7969V28.8044V30.3329H14.3279H18.9697V28.8044H14.3279V22.2188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4844 27.7939H34.7053V19.0391H21.4844V27.7939ZM22.1015 19.7066H34.0874V27.1263H22.1015V19.7066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9882 29.4468L34.7041 28.2344H21.4259L21.1485 29.4468H21.1367V30.1421H35.0017V29.4468H34.9882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34766 18.4206H18.5686V9.66406H5.34766V18.4206ZM5.96646 10.3325H17.9523V17.7522H5.96646V10.3325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8515 20.0779L18.5673 18.8672H5.2909L5.01345 20.0779H5V20.7732H18.8658V20.0779H18.8515Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_186068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(5 5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisDeactivatedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HIS_Deactivated_Icon.347608ae.svg";
export { ForwardRef as ReactComponent };